module.exports = __webpack_public_path__ + "assets/preview-eye.bf257097.svg";